import { secureApi } from '../Config/api'
import { GET, POST } from './apis'
import axios from 'axios'
import { authToken, removeToken, removeUser } from '../Redux/actions/authActions'
import paths from '../Config/paths'
import { message } from 'antd'
import moment from "moment-timezone"

const handleLogout = async (history, dispatch) => {
    try {
        dispatch(removeUser())
        dispatch(removeToken())

        history.push(paths?.LOGIN)
    } catch (err) {
        // console.error('Error during logout:', err)
    }
}

export const convertLocalToItalianTime = (time = moment()) => {
    try {
        let parsedTime

        if (typeof time === "string" && /^\d{2}:\d{2}(:\d{2})?$/.test(time)) {
            const today = moment().format("YYYY-MM-DD")
            parsedTime = moment(`${today} ${time}`, "YYYY-MM-DD HH:mm:ss")
        } else if (moment.isMoment(time)) {
            parsedTime = time
        } else if (time instanceof Date) {
            parsedTime = moment(time)
        } else {
            parsedTime = moment()
        }

        return parsedTime.clone().tz("Europe/Rome")
    } catch (err) {
        console.error("Error in convertLocalToItalianTime:", err)
        return moment().tz("Europe/Rome")
    }
}

export const convertItalianToLocalTime = (italyTime) => {
    if (!italyTime) return null
    try {
        let fullTime = italyTime
        if (/^\d{2}:\d{2}(:\d{2})?$/.test(italyTime)) {
            const today = moment().tz("Europe/Rome").format("YYYY-MM-DD")
            fullTime = `${today} ${italyTime}`
        }
        return moment.tz(fullTime, "YYYY-MM-DD HH:mm:ss", "Europe/Rome").local()
    } catch (err) {
        console.error("Error converting Italian time to local:", err)
        return null
    }
}

const verifyToken = async (history, dispatch) => {
    try {
        const data = await secureApi.get(GET?.VERIFY_TOKEN)
        // console.log('verifyToken data', data)
        if (data?.status === 429 || data?.message === "Too many requests, please try again later.") {
            message.error("Too many requests Please try again later.")
            return true
        }
        if (!data?.success) {
            // console.error('Token verification failed. Redirecting to login...')
            handleLogout(history, dispatch)
            return false
        } else {
            dispatch(authToken(data?.accessToken))
            return true
        }
    } catch (error) {
        console.error('Error verifying token:', error)
        // handleLogout(history, dispatch)
        // return false
    }
}

const shortText = (text, maxLength = 20) => {
    if (!text) return ''
    return text.length > maxLength ? text.slice(0, maxLength) + '…' : text
}

export {
    verifyToken,
    shortText,
}